module.exports = "<div class=\"box\"> <div class=\"logo-box\"> <div class=\"hover-color\"></div> <img class=\"logo\" src=\"{{getLogo()}}\"/> </div> <div class=\"name-box\"> <div> {{model.name}} </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/generic/tile/tile.component.html
// module id = 206
// module chunks = 0